import { Constraint } from "@planzone/dto";

function match(first: Constraint, second: Constraint): boolean {
  return (
    first.originEntityUuid === second.originEntityUuid &&
    first.targetEntityUuid === second.targetEntityUuid
  );
}

export { match };
